import { _Fetch, FormRequest, Upload, downloadJSON } from './utils';
import querystring from 'query-string';
import axios from 'axios';

const toQueryString = (values) => {
	return querystring.stringify(values);
};

// Contact Us API
export const postContact = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await FormRequest('/support', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

// Auth API
export const userLogin = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/login', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

// Admin page
export const requestUsersDownload = (values) => {
	let path = '/admin/users';
	if (values) {
		path = `/admin/users?${toQueryString(values)}`;
	}
	return axios({
		method: 'GET',
		url: path
	})
		.then((res) => {
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement('a'); link.href = url;
			link.setAttribute('download', 'users.csv');
			document.body.appendChild(link); link.click();
		})
		.catch((err) => { });
}

export const userSignUp = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/signup', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const checkVerifyData = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			// const res = await _Fetch(/verify", "post", body);
			const res = await _Fetch(`/dash/verify?verification_code=${body}`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const userVerify = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/verify`, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const changePassword = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/change-password', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const identifyEmail = (email) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/reset-password?${toQueryString({ email })}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const resetPassword = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/reset-password', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestOTP = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/user/request-otp`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const otpActivate = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/user/activate-otp`;
			const res = await _Fetch(url, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const otpRevoke = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/user/deactivate-otp`;
			const res = await _Fetch(url, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

// Wallet API
export const getAvailableCurrency = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/vault/coins`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getWallet = (page = 1, name = '', currency = '') => {
	return new Promise(async (resolve, reject) => {
		try {
			let url = `/dash/vault/user/wallets?page=${page}&&limit=10&&`;
			if (name !== '' || currency !== '') {
				if (name !== '') {
					url += `name=${name.toLocaleLowerCase()}&&`;
				}
				if (currency !== '') {
					url += `currency=${currency.toLocaleLowerCase()}`;
				}
			}
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const checkWalletName = (name) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/vault/${name}/check`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const postAddress = (name) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/vault/${name}/address`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getAsset = (name, page = 1, limit = 10) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(
				`/dash/vault/${name}/addresses?page=${page}&&limit=${limit}`,
				'get'
			);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getMaster = (name) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/vault/${name}/master`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getWalletBalance = (wallet) => {
	return new Promise(async (resolve, reject) => {
		let url = `/dash/vault/${wallet}/balance`;
		try {
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getTransaction = (name, page = 1, query = null) => {
	return new Promise(async (resolve, reject) => {
		try {
			let url = `/dash/vault/${name}/transactions?page=${page}&&limit=10`;
			if (query) {
				if (query.address !== '') {
					url += `&&address=${query.address}`;
				}
				if (query.type !== '') {
					url += `&&type=${query.type}`;
				}
				if (query.start_date !== '') {
					url += `&&start_date=${query.start_date}`;
				}
				if (query.end_date !== '') {
					url += `&&end_date=${query.end_date}`;
				}
			}
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const simpleWithdraw = (name, body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(
				`/dash/vault/${name}/withdraw/simple`,
				'post',
				body
			);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const withdraw = (name, body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/vault/${name}/withdraw`, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const addWallet = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/vault/wallet', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const deleteWallet = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/vault/wallet', 'delete', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getToken = (params) => {
	return new Promise(async (resolve, reject) => {
		try {
			let dataParams = '';
			if (Object.keys(params)) {
				dataParams = `?${toQueryString(params)}`;
			}
			const res = await _Fetch(`/dash/user/token${dataParams}`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

// Token API
export const addToken = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/user/token', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const deleteToken = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/user/token', 'delete', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const updateAsset = (name, body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/vault/${name}/webhook`, 'put', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const postExchange = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange`, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const putExchange = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange`, 'put', body);
			resolve(res);
		} catch (error) {
			console.error(error.response);
			reject(error);
		}
	});
};

export const getExchange = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getCollateral = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/${id}`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getPublicCollateral = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/public/${id}`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getPublicExchange = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/featured`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const deleteExchange = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange`, 'delete', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const notificationExchange = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(
				`/exchange/notification?exchange_id=${id}`,
				'put',
				{}
			);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getExchangeMsg = (id, page = 1) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(
				`/exchange/${id}/message?page=${page}&&limit=10`,
				'get'
			);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const postExchangeMsg = (id, body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/${id}/message`, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const deleteExchangeMsg = (exchangeId, msgId) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(
				`/exchange/${exchangeId}/message?message_id=${msgId}`,
				'delete'
			);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const pledgeXht = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/pledge`, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const withdrawXht = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/pledge`, 'delete', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getStats = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/stats`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getXhtPrice = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await fetch(
				'https://api.hollaex.com/v2/ticker?symbol=xht-usdt'
			);
			const data = await res.json();
			resolve(data);
		} catch (error) {
			reject(error);
		}
	});
};

export const getCrytoPrice = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await fetch('https://api.hollaex.com/v1/ticker/all');
			const data = await res.json();
			resolve(data);
		} catch (error) {
			reject(error);
		}
	});
};

export const getUserInfo = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/user`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const createWalletAddress = (type, network) => {
	return new Promise(async (resolve, reject) => {
		try {
			let queryParams = network ? toQueryString({ network }) : '';
			const res = await _Fetch(`/dash/user/address/${type}?${queryParams}`, 'post', {});
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const searchTransactions = (query) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(
				`/dash/vault/transaction/status${query}`,
				'get'
			);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const ResendVerificationCode = (email) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(
				`/dash/verify?email=${encodeURIComponent(email)}&resend=true`,
				'get'
			);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const uploadImage = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await Upload(`/exchange/image`, 'put', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getDeposits = (page = 1, limit = 10) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/user/deposits?currency=xht&page=${page}&limit=${limit}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getWithdrawals = (page = 1, limit = 10) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/user/withdrawals?currency=xht&page=${page}&limit=${limit}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getFeeData = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = '/constants';
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestWithdrawal = (body, params = {}) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/user/request-withdrawal?${toQueryString(params)}`;
			const res = await _Fetch(url, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const confirmWithdrawal = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = '/dash/user/confirm-withdrawal';
			const res = await _Fetch(url, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getMembers = (exchangeId, page) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/exchange/${exchangeId}/member?page=${page}&&limit=10`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const postMembers = (exchangeId, body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/exchange/${exchangeId}/member`;
			const res = await _Fetch(url, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const deleteMembers = (exchangeId, id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/exchange/${exchangeId}/member?member_id=${id}`;
			const res = await _Fetch(url, 'delete');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestAutoSweep = (walletName, data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/vault/${walletName}/sweep`;
			const res = await _Fetch(url, 'put', data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestManualSweep = (walletName, data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/vault/${walletName}/sweep`;
			const res = await _Fetch(url, 'post', data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestRestartWallet = (walletName) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/vault/${walletName}/restart`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getExchangeBilling = (params) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/invoice?${toQueryString(params)}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestStoreInvoice = (id, data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/invoice?invoice_id=${id}`;
			const res = await _Fetch(url, 'put', data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getNewExchangeBilling = (exchangeId = '') => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/exchange/pay?exchange_id=${exchangeId}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getCoins = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = '/coin';
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getPairs = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = '/pair';
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getUsers = (exchange_id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/operator/${exchange_id}/users`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const updateAssetCoins = (data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = '/coin';
			const res = await _Fetch(url, 'put', data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const updatePair = (data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = '/pair';
			const res = await _Fetch(url, 'put', data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const storeAsset = (data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = '/coin';
			const res = await _Fetch(url, 'post', data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const storePairs = (data) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = '/pair';
			const res = await _Fetch(url, 'post', data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const getExchangeUsers = (id, query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/network/${id}/users?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const getExchangeUser = (exchange_id, user_id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/network/${exchange_id}/user?user_id=${user_id}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const getExchangeBalance = (exchange_id, data) => {
	// let formProps = { ...data };
	return new Promise(async (resolve, reject) => {
		try {
			// const dataParams = toQueryString(formProps);
			const url = `/network/${exchange_id}/balance`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const getExchangeDeposits = (id, query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/network/${id}/deposits?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const getExchangeDepositDownload = (id, dataParams) => {
	let path = `/network/${id}/deposits`;
	if (dataParams) {
		path = `/network/${id}/deposits?${toQueryString(dataParams)}`;
	}
	return axios({
		method: 'GET',
		url: path
	})
		.then((res) => {
			const url = window.URL.createObjectURL(new Blob([res.data.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'deposit.csv');
			document.body.appendChild(link);
			link.click();
		})
		.catch((err) => { });
};

export const getExchangeWithdrawals = (id, query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/network/${id}/withdrawals?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const getExchangeWithdrawalDownload = (id, dataParams) => {
	let path = `/network/${id}/withdrawals`;
	if (dataParams) {
		path = `/network/${id}/withdrawals?${toQueryString(dataParams)}`;
	}
	return axios({
		method: 'GET',
		url: path
	})
		.then((res) => {
			const url = window.URL.createObjectURL(new Blob([res.data.data]));
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'withdrawals.csv');
			document.body.appendChild(link);
			link.click();
		})
		.catch((err) => { });
};

export const getActiveOrders = (id, query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/network/${id}/orders?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const StoreTransfer = (id, data) => {
	// let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/network/${id}/transfer`;
			const res = await _Fetch(url, 'post', data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const getPublicTrades = (id, query) => {
	// let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			// const dataParams = toQueryString(formProps);
			const url = `/network/${id}/trades`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
};

export const updateCloud = (body = {}, params = {}) => {
	return new Promise(async (resolve, reject) => {
		try {
			let dataParams = '';
			if (Object.keys(params)) {
				dataParams = `?${toQueryString(params)}`;
			}
			const res = await _Fetch(`/exchange/cloud${dataParams}`, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getWalletDeposits = (params) => {
	return new Promise(async (resolve, reject) => {
		try {
			let dataParams = toQueryString(params)
			const url = `/dash/user/deposits?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getWalletWithdrawals = (params) => {
	return new Promise(async (resolve, reject) => {
		try {
			let dataParams = toQueryString(params)
			const url = `/dash/user/withdrawals?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const storeBurn = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/network/burn', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const storeMint = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/network/mint', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getJob = (id, query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/exchange/jobs?exchange_id=${id}&${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getCoinParams = (price) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/coin/params?estimated_price=${price}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getPairParams = (price) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/pair/params?estimated_price=${price}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getCoinInfo = (query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/coin/info?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const setExchangePlan = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/exchange/plan', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestApplyOnKit = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/apply/${id}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getFees = (id, query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/network/${id}/fees?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const downloadFeesData = (id, query) => {
	let formProps = { ...query };
	const dataParams = toQueryString(formProps);
	const url = `/network/${id}/fees?${dataParams}`;
	return axios({
		method: 'GET',
		url: url
	})
		.then((res) => {
			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement('a'); link.href = url;
			link.setAttribute('download', 'fees.csv');
			document.body.appendChild(link); link.click();
		})
		.catch((err) => { });
};

export const settleFees = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/network/${id}/fees/settle`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getStakeAll = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/pledge/all`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getPrice = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/pricing`, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const cancelPledge = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/pledge/cancel-removal`, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestPlugins = (query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/plugins?${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestChargeCrypto = (crypto) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/user/charge-address/${crypto}`, 'post', {});
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
}

export const requestLogs = (id, query) => {
	let formProps = { ...query };
	return new Promise(async (resolve, reject) => {
		try {
			const dataParams = toQueryString(formProps);
			const url = `/exchange/cloud/logs?exchange_id=${id}&${dataParams}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const requestBackup = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/exchange/cloud/backup?exchange_id=${id}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getActivation = (name) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/dash/activation?name=${name}`;
			const res = await _Fetch(url, 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const postInvoice = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/invoice', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const downloadPlugin = (name) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/plugin/download?name=${name}`;
			const res = await _Fetch(url, 'get');
			downloadJSON(res.data);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const confirmLogin = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/confirm-login', 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const uploadCoinLogo = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await Upload(`/exchange/image`, 'post', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const getVerificationCode = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/user/request-verification-code', 'get');
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const updateToken = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/user/token', 'put', body);
			resolve(res);
		} catch (error) {
			reject(error);
		}
	});
};

export const putUserVerify = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/dash/user', 'put', body)
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
}

export const putUserPhoneDetail = (body, id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/verification/confirm-sms?exchange_id=${id}`, 'post', body)
			resolve(res);
		} catch (error) {
			reject(error)
		}
	})
}

export const getUserVerify = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/exchange/verification/name?exchange_id=${id}`;
			const res = await _Fetch(url, 'get')
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
}

export const getSmsCode = (body, id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const url = `/exchange/verification/request-sms?exchange_id=${id}`
			const res = await _Fetch(url, 'post', body)
			resolve(res);
		} catch (error) {
			reject(error);
		}
	})
}

export const putBusinessVerify = (body) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch('/exchange', 'put', body)
			resolve(res);
		}
		catch (error) {
			reject(error);
		}
	})
}

export const getAgreement = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/verification/signature?exchange_id=${id}`, 'get')
			resolve(res);
		}
		catch (error) {
			reject(error);
		}
	})
}

export const getPluginData = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/plugins`, 'get')
			resolve(res);
		}
		catch (error) {
			reject(error);
		}
	})
}

export const getActivationDetail = () => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`dash/activations`, 'get')
			resolve(res);
		}
		catch (error) {
			reject(error);
		}
	})
}

export const getActivate = (name) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`plugin/activate?name=${name}`, 'get')
			resolve(res);
		}
		catch (error) {
			reject(error);
		}
	})
}

export const getIframeUrl = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/exchange/logs?exchange_id=${id}`, 'get')
			resolve(res);
		}
		catch (error) {
			reject(error);
		}
	})
}

export const getDashDiscount = (id) => {
	return new Promise(async (resolve, reject) => {
		try {
			const res = await _Fetch(`/dash/discount`, 'post',id)
			resolve(res);
		}
		catch (error) {
			reject(error);
		}
	})
}